/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Use_4_TermInputs */

const en_svc_integration_use_4_term = /** @type {(inputs: Svc_Integration_Use_4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your product`)
};

const lv_svc_integration_use_4_term = /** @type {(inputs: Svc_Integration_Use_4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu produkts`)
};

/**
* | output |
* | --- |
* | "Your product" |
*
* @param {Svc_Integration_Use_4_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_use_4_term = /** @type {((inputs?: Svc_Integration_Use_4_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Use_4_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_use_4_term(inputs)
	return en_svc_integration_use_4_term(inputs)
});